var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticStyle: { width: "100%" } }, [
      _c("h3", { staticClass: "normal" }, [_vm._v("猩号意见反馈")]),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "table-opinion",
          attrs: {
            width: "100%",
            cellspacing: "0",
            cellpadding: "0",
            border: "0"
          }
        },
        [
          _c("th", [
            _vm._m(0),
            _vm._v(" "),
            _c("tr", [
              _c("td", [
                _c("div", [
                  _c("input", {
                    attrs: { type: "file", id: "xinghaoimage", multiple: "" },
                    on: { change: _vm.chooseImage }
                  })
                ]),
                _vm._v(" "),
                _vm.srcList.length > 0
                  ? _c(
                      "div",
                      {
                        staticStyle: { display: "flex", "margin-left": "150px" }
                      },
                      _vm._l(_vm.srcList, function(src, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "imageBoxMini" },
                          [
                            _c("img", {
                              attrs: {
                                src: src,
                                preview: "3",
                                "preview-text": "猩号建议图"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticStyle: {
                                  display: "block",
                                  width: "50px",
                                  "text-align": "center"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.delImage(index)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  删除\n                "
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入内容" },
                    model: {
                      value: _vm.describe,
                      callback: function($$v) {
                        _vm.describe = $$v
                      },
                      expression: "describe"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("td", [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.platform,
                        expression: "platform"
                      }
                    ],
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.platform = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "安卓" } }, [
                      _vm._v("安卓")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "ios" } }, [_vm._v("ios")])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.saveInfo()
                        }
                      }
                    },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { display: "flex" } }, [
        _c(
          "div",
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%", "margin-top": "50px" },
                attrs: { data: _vm.opinionList, stripe: "", border: "" }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "picture",
                    label: "示意图",
                    width: "400",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            _vm._l(scope.row.images, function(p, index) {
                              return _c("div", { key: index }, [
                                _c("img", {
                                  staticStyle: {
                                    width: "100px",
                                    height: "100px"
                                  },
                                  attrs: {
                                    src: p,
                                    preview: "3",
                                    "preview-text": "猩号建议图"
                                  }
                                })
                              ])
                            }),
                            0
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "describe",
                    label: "建议描述",
                    width: "400",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "platform",
                    label: "平台",
                    width: "200",
                    filters: [
                      { text: "安卓", value: "安卓" },
                      { text: "ios", value: "ios" }
                    ],
                    "filter-method": _vm.filterHandler,
                    "filtered-value": ["安卓"],
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "create_time",
                    label: "时间",
                    width: "200",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "status",
                    label: "状态",
                    width: "100",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: scope.row.status,
                                  expression: "scope.row.status"
                                }
                              ],
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      scope.row,
                                      "status",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.changestatus(scope.row)
                                  }
                                ]
                              }
                            },
                            [
                              _c("option", { attrs: { value: "待讨论" } }, [
                                _vm._v("待讨论")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "暂缓" } }, [
                                _vm._v("暂缓")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "拒绝" } }, [
                                _vm._v("拒绝")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "开发中" } }, [
                                _vm._v("开发中")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "已完成" } }, [
                                _vm._v("已完成")
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "chat-record" },
          _vm._l(_vm.chatsList, function(chat, index) {
            return _c("div", { key: index, staticClass: "onechat" }, [
              _c("div", { staticClass: "userchat" }, [
                _c("img", {
                  staticStyle: {
                    width: "50px",
                    height: "50px",
                    "border-radius": "50%"
                  },
                  attrs: { src: chat.avatar }
                }),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(chat.nickname))])
              ]),
              _vm._v(" "),
              _c("div", [
                chat.type == 1
                  ? _c("div", { staticClass: "onechatcontent" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(chat.content) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                chat.type == 2
                  ? _c(
                      "div",
                      {
                        staticClass: "onechatcontent",
                        on: {
                          click: function($event) {
                            return _vm.addTalkImage(chat.content)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: chat.content,
                            preview: "3",
                            "preview-text": "猩号建议图"
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-left": "15px" } }, [
                  _vm._v(
                    "\n              发布时间：" +
                      _vm._s(chat.create_time) +
                      "\n            "
                  )
                ])
              ])
            ])
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticStyle: { width: "700px" } }, [_vm._v("示意图")]),
      _vm._v(" "),
      _c("td", { staticStyle: { width: "20%" } }, [_vm._v("建议描述")]),
      _vm._v(" "),
      _c("td", { staticStyle: { width: "10%" } }, [_vm._v("平台")]),
      _vm._v(" "),
      _c("td", { staticStyle: { width: "10%" } }, [_vm._v("操作")]),
      _vm._v(" "),
      _c("td", { staticStyle: { width: "40%" } }, [_vm._v("聊天记录")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f893994a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f893994a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/opinion.vue
// module id = null
// module chunks = 